var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('my-header',{attrs:{"page_name":_vm.$t('navigation.headerTitles.upgrades'),"show_usermenu":""}}),_c('reference-grid',{attrs:{"gridData":_vm.getUpgradesTable,"columns":_vm.columnDefs,"gridType":"upgrades"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }